import { useEffect, useContext } from 'react';
import { AsgFwContext } from '../contexts';
import { useDispatch, useSelector } from 'react-redux';
import { useAsgActions } from '../../../shared/src/hooks/use-asg-actions.hook';

export const useWinners = (
    dependencies = [],
) => {
    const AsgFW = useContext(AsgFwContext);
    const { setWinners } = useAsgActions();
    const dispatch = useDispatch();
    const {
        platformReady,
        platformGamesReady,
        isNeoCmsIntegrationEnabled,
    } = useSelector((state) => state.app);
    // if NeoCMS enabled - games ready fired immediately, so wait for platform ready too.
    const isReadyToGetWinners = isNeoCmsIntegrationEnabled
        ? platformReady && platformGamesReady
        : platformGamesReady;

    useEffect(() => {
        if (isReadyToGetWinners) {
            AsgFW.setGetWinnersData((winnersResult) => {
                // exclude winners of games not present on brand (winner.game === undefined)
                const winnersPresentInBrand = winnersResult.filter((winner) => winner.game);

                // set in state
                dispatch(setWinners(winnersPresentInBrand));
            });
        }
    }, [...dependencies, isReadyToGetWinners]);
};
